//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import get from 'lodash/get';
import dayjs from 'dayjs';

// TODO:BRO-1276: replace DTacoRating, DDropdownItem, DButton where possible
import { DButton } from '@appsumo/dorado-button';
import { SUMO_DAY_BANNER_TEXT } from '@/constants/global';
import LegacyDropdown from '../ui/LegacyDropdown.vue';
import TacoRating from '../utilities/TacoRating.vue';
import PlusImage from '../../../static/images/home/as-plus-2.svg';
import PDPTimer from './util/PDPTimer.vue';
import DealUpsellCallout from './util/DealUpsellCallout.vue';
import SubmitEmailMixin from '../../mixins/submit-email';
import PDPScrollToElementMixin from './mixins/PDPScrollToElementMixin';
import PricingCardGuaranteeWrapper from './PricingCardGuaranteeWrapper.vue';
import ListingTypeLogo from './ListingTypeLogo.vue';
import { LISTING_TYPES_WITH_LOGO } from '~/constants/listing-types';
import DealBannerContent from './DealBannerContent.vue';

export default {
  LISTING_TYPES_WITH_LOGO,
  components: {
    LegacyDropdown,
    PDPTimer,
    TacoRating,
    DButton,
    PricingCardGuaranteeWrapper,
    DealUpsellCallout,
    ListingTypeLogo,
    DealBannerContent,
  },
  mixins: [SubmitEmailMixin, PDPScrollToElementMixin],
  props: {
    deal: {
      type: Object,
      required: true,
    },
    buyButton: {
      type: Object,
      required: true,
    },
    planTypeText: {
      type: String,
      required: true,
    },
    subheader: {
      type: String,
      required: false,
      default: '',
    },
    plans: {
      type: Array,
      required: false,
      default: () => [],
    },
    // TODO temp user object to be replaced by this.$store.state.session.user
    user: {
      type: Object,
      required: true,
    },
    idSuffix: {
      type: String,
      required: true,
    },
    isPricingCardEmailSubmitted: {
      type: Boolean,
      required: true,
    },
    bannerDetails: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      plusImage: PlusImage,
      isMounted: false,
      isDisabled: false,
      tooltipText: `This is a short description of what AppSumo Select means.
                    We should cap this to only be a few lines in length.`,
      selectedPlan: this.plans?.length ? this.plans[0] : null,
      showStickyBuyNow: false,
      mobileMatchMedia: null,
      buyNowObserver: null,
      footerObserver: null,
    };
  },
  computed: {
    bannerBgColor() {
      return this.bannerDetails?.bg_color;
    },
    borderTopClass() {
      if (!this.bannerBgColor) {
        return null;
      }

      return `sumo-border-top-4-${this.bannerBgColor}`;
    },
    infoDealQuestionText() {
      return `Want to see ${this.deal.public_name} on AppSumo?`;
    },
    emailCaptureButtonText() {
      return this.deal.is_info ? 'Yes, bring to AppSumo' : 'Stay in the know';
    },
    stickyFooterButtonText() {
      return this.deal.is_info ? 'I\'d buy it' : 'Email me';
    },
    emailInputId() {
      return `email-${this.idSuffix}`;
    },
    buyButtonText() {
      if (this.buyButton.is_draft) {
        return 'Buy now (Draft)';
      }

      // jw: is_coming_soon will be true if the current user does not have early access, so we want
      //     to handle these cases first since early access behavior should trump coming soon.
      if (!this.earlyAccessOrLastCall && this.buyButton.is_coming_soon) {
        return 'Coming soon';
      }

      if (this.buyButton.is_ended) {
        return 'Sold out';
      }

      if (this.buyButton.is_get_now) {
        return this.deal.is_free ? 'Get now for FREE' : 'Get now';
      }

      return 'Buy now';
    },
    clickthroughUrl() {
      return this.deal.clickthrough_url;
    },
    disabledBuyButton() {
      return this.disabledState || this.buyButton.is_coming_soon;
    },
    canAddToCart() {
      const { buyButton } = this;
      return !(buyButton.is_draft || buyButton.is_ended || buyButton.is_coming_soon);
    },
    defaultPriceText() {
      const formattedPrice = this
        .$options
        .filters
        .currencyWithOptionalDecimal(this.deal.default_price);

      if (this.deal.plan_stack_count > 1) {
        return `Starting at ${formattedPrice}`;
      }

      return formattedPrice;
    },
    selectedPriceText() {
      if (this.selectedPlan) {
        return this.getPlanDisplayText(this.selectedPlan.public_name, this.selectedPlan.price);
      }

      return this.defaultPriceText;
    },
    isReportable() {
      // let's only allow reporting for self-listing/marketplace
      if (!this.deal.is_marketplace) {
        return false;
      }

      // info deals are 'marketplace', but we control them, so let's not allow reporting
      if (this.deal.is_info) {
        return false;
      }

      return this.user?.isAuthenticated || this.user?.isStaff;
    },
    reportUrl() {
      // jl: as this method's used right now, user is guaranteed to be non-empty.
      // while it won't error due to the presence of a default user value, for future uses
      // of reportUrl(), let's make sure the user object is non-empty
      return `https://report-offer.paperform.co/?deal_id=${this.deal.id}&deal_slug=
              ${this.deal.slug}&email=${this.user.email}`;
    },
    isAuthenticated() {
      return this.user.isAuthenticated;
    },
    signupText() {
      return this.isAuthenticated
        ? 'Don\'t ever relive this heartbreak— sign up below to get the latest deals!'
        : 'Don\'t ever relive this heartbreak— enter your email to get the latest deals!';
    },
    hasPlans() {
      return this.plans && this.plans.length > 1;
    },
    dropdownText() {
      // jw: since this is only called when we have multiple plans we should always have a
      //     selectedPlan option. Let's build this method with that assumption.
      return this.getPlanDisplayText(this.selectedPlan.public_name, this.selectedPlan.price);
    },
    dropdownValue() {
      // jw: just like above, we should always have a selectedPlan since this is only called where
      //     hasPlans is true. See data.selectedPlan initial definition if you don't agree!
      return this.selectedPlan.price;
    },
    dropdownOptions() {
      return this.plans.map((plan) => ({
        id: plan.id,
        value: plan.price,
        display: this.getPlanDisplayText(plan.public_name, plan.price),
      }));
    },
    disabledState() {
      if (this.buyButton.is_ended) {
        return true;
      }
      if (this.hasPlans) {
        return !this.selectedPlan;
      }
      return this.isDisabled;
    },
    isOriginals() {
      return (get(this, ['deal', 'products', 0, 'internal_product_tags'], []) || []).includes('originals');
    },
    isOneTimePurchase() {
      if (this.selectedPlan.plan_desc === 'One Time Purchase of') {
        return true;
      }

      // an: When only has one price
      return !this.hasPlans && !!this.deal.default_price;
    },
    currentlyBeforeNextDealStage() {
      const nextStageStartDate = this.deal?.stage_details?.next_stage_start_date;
      if (!nextStageStartDate) {
        return false;
      }

      const dayjsNow = dayjs();
      const diffInMilliseconds = dayjs(nextStageStartDate).diff(dayjsNow);

      return diffInMilliseconds > 0;
    },
    showBannerDetails() {
      if (!this.bannerDetails?.text) {
        return false;
      }

      return this.currentlyBeforeNextDealStage
          || this.bannerDetails?.text === SUMO_DAY_BANNER_TEXT;
    },
    displayTimer() {
      return this.deal.active_timer && this.currentlyBeforeNextDealStage;
    },
    inactiveIndefinitely() {
      return this.deal.stage_details.is_inactive_indefinitely;
    },
    earlyAccessOrLastCall() {
      return this.buyButton.is_early_access || this.buyButton.is_last_call;
    },
    notPlusAndEarlyAccessOrLastCall() {
      return !this.user.hasPlus && this.earlyAccessOrLastCall;
    },
  },
  mounted() {
    this.isMounted = true;

    this.mobileMatchMedia = window.matchMedia('(max-width: 991px)');
    this.mobileMatchMedia.addListener(this.toggleObservers);

    this.toggleObservers(this.mobileMatchMedia);
  },
  beforeDestroy() {
    this.mobileMatchMedia.removeListener(this.toggleObservers);
    this.destroyObservers();
  },
  methods: {
    // seems silly, but let's centralize this common format into a helper function.
    getPlanDisplayText(planName, price) {
      return `${planName} : ${this.$options.filters.currencyWithOptionalDecimal(price)}`;
    },
    onClickEmailMeMobile() {
      const { soldOutEmailCapture } = this.$refs;
      this.$_scrollToElement(soldOutEmailCapture);
    },
    toggleObservers(event) {
      if (event.matches) {
        this.registerBuyNowObserver();
      } else {
        // remove any observer
        this.showStickyBuyNow = false;
        this.destroyObservers();
      }
    },
    registerBuyNowObserver() {
      this.buyNowObserver = new IntersectionObserver((entries) => {
        const [buyNowEntry] = entries;
        const isAfterViewport = buyNowEntry.boundingClientRect.bottom <= 0;

        if (!buyNowEntry.isIntersecting && isAfterViewport) {
          this.showStickyBuyNow = true;
          this.registerFooterObserver();
        } else if (this.footerObserver) {
          this.showStickyBuyNow = false;
          this.footerObserver.disconnect();
          this.footerObserver = null;
        }
      });

      this.buyNowObserver.observe(this.$refs.buynow);
    },
    registerFooterObserver() {
      const footer = document.querySelector('footer');

      this.footerObserver = new IntersectionObserver((entries) => {
        const [footerEntry] = entries;
        this.showStickyBuyNow = !footerEntry.isIntersecting;
      });

      this.footerObserver.observe(footer);
    },
    destroyObservers() {
      if (this.buyNowObserver) {
        this.buyNowObserver.disconnect();
        this.buyNowObserver = null;
      }

      if (this.footerObserver) {
        this.footerObserver.disconnect();
        this.footerObserver = null;
      }
    },
    selectPlan(plan) {
      this.selectedPlan = this.plans.find((p) => p.id === plan.id);
    },
    async postSignupOrAddToCart() {
      if (this.buyButton.is_ended) {
        await this.postEmailWaitlistSignUp();
      } else {
        this.postAddToCart();
      }
    },
    postAddToCart() {
      this.isDisabled = true;
      const data = new FormData();
      data.append('id', this.deal.id);
      if (this.selectedPlan) {
        data.append('plan_id', this.selectedPlan.id);
        data.append('quantity', this.selectedPlan.codes);
      } else if (this.deal.default_plan) {
        data.append('plan_id', this.deal.default_plan.id);
      }
      if (this.deal.is_free) {
        const quantity = (this.deal.use_licensing) ? 1 : this.deal.default_plan.codes;
        data.append('quantity', quantity);
      }
      axios.post('/cart/add/', data, this.$_formHeaders())
        .then(() => {
          this.isDisabled = false;
          if (window) {
            window.location = '/cart/';
          }
        })
        .catch(() => {
          this.$toastr.e('Something has gone wrong with this request. Please try again.');
          this.isDisabled = false;
        });
    },
    async postEmailWaitlistSignUp() {
      if (!this.$_validateEmail(this.emailAddress)) {
        this.$toastr.w('Please use a valid email address.');
      } else {
        const data = this.$_createFormDataWithUtm();
        data.append('deal_slug', this.deal.slug);
        data.append('waitlist_email', this.emailAddress);

        const showToastMessageOnSuccess = false;
        await this.$_sendEmailRequest('/deal/waitlist-signup/', data, showToastMessageOnSuccess);
      }
    },
  },
};
